import {
    faSoccerBall,
    faInbox,
    faUsers,
    faTrophy,
    faClipboard,
    faDumbbell,
    faArrowRightArrowLeft,
    faSeedling,
    faChartBar,
    faMoneyBill,
    faCog,
    faMicrochip,
    faBug,
    faPerson,
    faUserTie,
    faHeartPulse,
    faAmbulance,
    faExchangeAlt,
    faTshirt,
    faBookOpen,
    faClock,
    faCalendar,
    faHistory,
    faChartLine,
    faTasks,
    faFire,
    faLeaf,
    faHome,
    faList,
    faFilm,
    faPersonSkiing,
    faPersonRunning,
    faArrowRight,
    faCheckCircle,
    faExclamationTriangle,
    faFilter,
    faSearch,
    faPencil,
    faTrash,
    faPlus,
    faMinus,
    faExpand,
    faCompress,
    faEye,
    faEyeSlash,
    faDownload,
    faUpload,
    faFileDownload,
    faGraduationCap,
    faAward,
    faBullseye,
    faHand,
    faChartPie,
    faBell,
    faEnvelope,
    faComment,
    faShare,
    faCopy,
    faLink,
    faExternalLink,
    faShield,
    faBrain,
    faCrosshairs,
    faDice,
    faLightbulb,
    faCircle,
    IconDefinition,
    faChalkboardUser,
    faSun,
    faMoon,
} from '@fortawesome/free-solid-svg-icons';

export const iconMap: Record<string, IconDefinition> = {
    // Navigation
    'home': faSoccerBall,
    'inbox': faInbox,
    'team': faUsers,
    'competitions': faTrophy,
    'tactics': faClipboard,
    'training': faDumbbell,
    'transfers': faArrowRightArrowLeft,
    'youth': faSeedling,
    'statistics': faChartBar,
    'finances': faMoneyBill,
    'assistant': faChalkboardUser,
    'manager': faUserTie,
    'game': faCog,
    'aimode': faMicrochip,
    'debug': faBug,
    'history': faHistory,


    // Common actions
    'edit': faPencil,
    'delete': faTrash,
    'add': faPlus,
    'remove': faMinus,
    'expand': faExpand,
    'collapse': faCompress,
    'view': faEye,
    'hide': faEyeSlash,
    'download': faFileDownload,
    'upload': faUpload,
    'filter': faFilter,
    'search': faSearch,

    // Status/Info
    'health': faHeartPulse,
    'injury': faAmbulance,
    'success': faCheckCircle,
    'warning': faExclamationTriangle,
    'info': faChartLine,

    // Game related
    'player': faPerson,
    'award': faAward,
    'target': faBullseye,
    'formation': faChartPie,
    'tactics-setup': faClipboard,
    'team-setup': faUsers,
    'list': faList,
    'calendar': faCalendar,
    'clock': faClock,
    'chart': faChartLine,
    'defense': faShield,
    'midfield': faBrain,
    'attack': faCrosshairs,
    'gk': faHand,

    // Communication
    'message': faEnvelope,
    'comment': faComment,
    'feedback': faComment,
    'share': faShare,
    'copy': faCopy,
    'link': faLink,
    'external': faExternalLink,

    // Theme
    'sun': faSun,
    'moon': faMoon,
};

export const getIcon = (iconId: string): IconDefinition | undefined => {
    return iconMap[iconId];
};

export const hasIcon = (iconId: string): boolean => {
    return iconId in iconMap;
};

export const getLeagueColor = (leagueName: string, leagueNames: string[]): string => {
    const leagueIndex = leagueNames.indexOf(leagueName);

    // Map league index to color by tier (rich, saturated colors)
    const tierColors = ['#E63946', '#0077B6', '#06A77D', '#7209B7']; // Red, Blue, Green, Purple
    return tierColors[leagueIndex] || tierColors[tierColors.length - 1];
};
